import Vue from 'vue'
import VueRouter from 'vue-router'
import Nav from '../components/Nav.vue'
import Footer from '../components/Footer.vue'
import Terms from '../views/Terms.vue'
import Login from '../views/Login.vue'
import SignupCompany from '../views/SignupCompany.vue'
import SignupDeveloper from '../views/SignupDeveloper.vue'
import SignupDeveloperProfile from '../views/SignupDeveloperProfile.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import RecruitHome from '../views/RecruitHome.vue'
import RecruitJobs from '../views/RecruitJobs.vue'
import RecruitJob from '../views/RecruitJob.vue'
import RecruitJobEdit from '../views/RecruitJobEdit.vue'
import RecruitJobAdd from '../views/RecruitJobAdd.vue'
import RecruitSource from '../views/RecruitSource.vue'
import RecruitCompanyEdit from '../views/RecruitCompanyEdit.vue'
import SalesPageCompany from '../views/SalesPageCompany.vue'
import SettingsHome from '../views/SettingsHome.vue'
import SettingsGeneral from '../views/SettingsGeneral.vue'
import SettingsApps from '../views/SettingsApps.vue'
import SettingsProfilePreview from '../views/SettingsProfilePreview.vue'
import SettingsChangePassword from '../views/SettingsChangePassword.vue'

import store from '@/store'
import { client } from '@/resources'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'home',
        components: {
            nav: Nav,
            footer: Footer,
            body: require('../views/Home.vue').default,
        },
        meta: {
            clearNav: true,
            clearNavMaxScrollY: 50,
            title: ''
        },
    },
    {
        path: '/jobs/search/:seoSlug',
        name: 'alsoHome',
        components: {
            nav: Nav,
            footer: Footer,
            body: require('../views/HomeClone.vue').default,
        },
        meta: {
            clearNav: true,
            clearNavMaxScrollY: 50,
            title: '',
        },
    },
    {
        path: '/login',
        name: 'login',
        components: {
            body: Login,
        },
        beforeEnter(to, from, next) {
            store.commit('logout')
            next()
        },
        meta: {
            wrapperClasses: ['full-blue-page']
        }
    },
    {
        path: '/logout',
        name: 'logout',
        components: {},
        beforeEnter(to, from, next) {
            store.commit('logout')
            window.location.href = '/'
        },
    },
    {
        path: '/login/password/reset',
        name: 'forgotPassword',
        components: {
            body: ForgotPassword,
        },
    },
    {
        path: '/tos',
        name: 'terms',
        components: {
            nav: Nav,
            footer: Footer,
            body: Terms
        },
    },
    // {
    //     path: '/profile/password/change',
    //     name: 'changePassword',
    //     components: {
    //         body: ChangePassword,
    //     },
    //     meta: {
    //         loginRequired: true,
    //         wrapperClasses: ['full-blue-page']
    //     },
    // },
    // Listings
    {
        path: '/jobs/:slug',
        name: 'listingsSingle',
        components: {
            nav: Nav,
            footer: Footer,
            body: require('../views/JobListing.vue').default,
        },
    },
    // Signup
    {
        path: '/signup/company',
        name: 'signupCompany',
        components: {
            nav: Nav,
            footer: Footer,
            body: SignupCompany,
        },
    },
    {
        path: '/signup/developer',
        name: 'signupDeveloper',
        components: {
            nav: Nav,
            footer: Footer,
            body: SignupDeveloper,
        },
    },
    {
        path: '/signup/developer/profile',
        name: 'signupDeveloperProfile',
        components: {
            nav: Nav,
            footer: Footer,
            body: SignupDeveloperProfile,
        },
    },
    // Settings
    {
        path: '/settings/profile/edit',
        name: 'settingsDeveloperProfile',
        components: {
            nav: Nav,
            footer: Footer,
            body: SignupDeveloperProfile,
        },
    },
    {
        path: '/settings',
        components: {
            nav: Nav,
            footer: Footer,
            body: SettingsHome,
        },
        children: [{
            path: '',
            name: 'settingsGeneral',
            component: SettingsGeneral
        }, {
            path: '/settings/applications',
            name: 'settingsApps',
            component: SettingsApps
        }, {
            path: '/settings/profile',
            name: 'settingsDeveloperProfilePreview',
            component: SettingsProfilePreview
        }, {
            path: '/settings/password/change',
            name: 'settingsChangePassword',
            component: SettingsChangePassword
        }]
    },
    // Upgrade
    {
        path: '/upgrade/:companyId',
        name: 'upgrade',
        components: {
            nav: Nav,
            footer: Footer,
            body: SalesPageCompany
        }
    },
    // {
    //     path: '/signup/developer/:step',
    //     name: 'signupDeveloper',
    //     components: {
    //         nav: Nav,
    //         body: Signup
    //     },
    //     beforeEnter(to, from, next) {
    //         localStorage.clear()
    //         next()
    //     }
    // },
    {
        path: '/dashboard/:companyId',
        components: {
            nav: Nav,
            footer: Footer,
            body: RecruitHome,
        },
        children: [{
            path: '',
            name: 'recruitHome',
            component: RecruitJobs
        }, {
            path: '/dashboard/:companyId/source',
            name: 'recruitSource',
            component: RecruitSource
        }, {
            path: '/dashboard/:companyId/jobs/create',
            name: 'recruitJobAdd',
            component: RecruitJobAdd
        }, {
            path: '/dashboard/:companyId/jobs/:listingId',
            name: 'recruitJobView',
            component: RecruitJob
        }, {
            path: '/dashboard/:companyId/jobs/:listingId/edit',
            name: 'recruitJobEdit',
            component: RecruitJobEdit
        }, {
            path: '/dashboard/:companyId/profile',
            name: 'recruitCompanyEdit',
            component: RecruitCompanyEdit
        }]
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) => {
    if (!store.getters.token && to.meta.loginRequired) {
        return next({ name: 'login', query: { redirect: to.fullPath } })
    }

    if (to.meta.staffRequired && !store.getters.isSuperuser) {
        return next({ name: 'login' })
    }

    if(to.meta.title) {
        document.title = `${to.meta.title} | Node.js Jobs`
    } else {
        document.title = 'Node.js Jobs'
    }

    store.commit('setNavClear', {
        isClear: !!to.meta.clearNav,
        maxScrollY: to.meta.clearNavMaxScrollY || 10
    })
    
    store.commit('setWrapperClasses', to.meta.wrapperClasses || [])

    window.scrollTo(0, 0)

    next()
})

client.tokenBecomesExpired = function () {
    router.push({ name: 'login' })
}

export default router
